import type { BlogSection } from '../types/blog';

const MID_SUBSCRIBE_ID = 'ggj-mid-subscribe-cta';

const SUBSCRIBE_CTA: BlogSection = {
  id: MID_SUBSCRIBE_ID,
  post_id: '',
  position: -1,
  type: 'cta',
  heading: null,
  data: {
    headline: 'Stay Updated',
    description:
      'Get the latest career insights and job search tips delivered to your inbox.',
    cta_kind: 'subscribe',
  },
  created_at: '',
};

/** Every `cta` section renders the email subscribe UI — never keep one at the bottom. */
function isEmailSubscribeSection(section: BlogSection): boolean {
  return section.type === 'cta';
}

function midTextInsertIndex(sections: BlogSection[]): number {
  const textIndices: number[] = [];
  sections.forEach((s, i) => {
    if (s.type === 'text') textIndices.push(i);
  });

  if (textIndices.length === 0) return Math.floor(sections.length / 2);
  const midTextSlot = Math.max(0, Math.ceil(textIndices.length / 2) - 1);
  return textIndices[midTextSlot] + 1;
}

/**
 * Exactly one "Stay Updated" subscribe box, placed around the middle of the article.
 * Removes all existing cta sections (they all render subscribe UI) and re-inserts one.
 */
export function placeMidSubscribeCta(sections: BlogSection[]): BlogSection[] {
  const existingCta = sections.find(isEmailSubscribeSection);
  const withoutCtas = sections.filter((s) => !isEmailSubscribeSection(s));
  const insertAt = midTextInsertIndex(withoutCtas);

  const ctaSection = existingCta
    ? {
        ...existingCta,
        data: {
          headline: 'Stay Updated',
          description:
            String(existingCta.data?.description ?? existingCta.data?.body ?? '') ||
            'Get the latest career insights and job search tips delivered to your inbox.',
          cta_kind: 'subscribe',
        },
      }
    : SUBSCRIBE_CTA;

  return [
    ...withoutCtas.slice(0, insertAt),
    ctaSection,
    ...withoutCtas.slice(insertAt),
  ];
}
